// Dados fictícios (mock) do módulo de Finanças — nada disso vem do banco ainda.
import { formatBRL } from '@/components/foundations/Amount';

export const brl = formatBRL;

export const CATEGORIES = [
  { id: 'moradia', name: 'Moradia', color: '#183b56', total: 1800 },
  { id: 'compras', name: 'Compras', color: '#e5b84c', total: 1532.4 },
  { id: 'mercado', name: 'Mercado', color: '#17996a', total: 1240.5 },
  { id: 'restaurantes', name: 'Restaurantes', color: '#dfa41b', total: 860.2 },
  { id: 'transporte', name: 'Transporte', color: '#2a6fd6', total: 410.9 },
  { id: 'assinaturas', name: 'Assinaturas', color: '#d9534f', total: 189.7 },
];
export const CATEGORY_OPTIONS = ['Mercado', 'Casa', 'Eletrônicos', 'Compras', 'Lazer', 'Restaurantes', 'Transporte'];

export const MONTH = { label: 'Outubro 2026', income: 7850, expenses: 6033.7, newPurchases: 2412.7, oldInstallments: 1046.2, fixed: 2574.8 };

export type FinTx = {
  id: string; date: string; desc: string; category: string; account: string; installment?: string;
  amount: number; purchaseDate?: string; total?: number; bill?: string; pluggyCategory: string; cnpj?: string; status: 'POSTED' | 'PENDING';
};
export const FIN_TX: FinTx[] = [
  { id: 't1', date: '22 out 2026', desc: 'IFOOD *RESTAURANTE EXEMPLO', category: 'Restaurantes', account: 'Cartão •••• 0597', amount: -58.9, bill: 'nov/2026', pluggyCategory: 'Food delivery', status: 'POSTED' },
  { id: 't2', date: '21 out 2026', desc: 'MERCADO EXEMPLO LTDA', category: 'Mercado', account: 'Cartão •••• 0597', amount: -312.45, bill: 'nov/2026', pluggyCategory: 'Groceries', status: 'POSTED' },
  { id: 't3', date: '20 out 2026', desc: 'LOJA ELETRO EXEMPLO', category: 'Eletrônicos', account: 'Cartão •••• 0597', installment: '3/10', amount: -249.9, purchaseDate: '20/08/2026', total: 2499, bill: 'nov/2026', pluggyCategory: 'Electronics', cnpj: '00.000.000/0001-00', status: 'POSTED' },
  { id: 't4', date: '20 out 2026', desc: 'PIX RECEBIDO · SALÁRIO EXEMPLO', category: 'Salário', account: 'Conta Inter', amount: 7500, pluggyCategory: 'Salary', status: 'POSTED' },
  { id: 't5', date: '19 out 2026', desc: 'UBER *TRIP', category: 'Transporte', account: 'Cartão •••• 0597', amount: -23.4, bill: 'nov/2026', pluggyCategory: 'Taxi and ride-hailing', status: 'POSTED' },
  { id: 't6', date: '18 out 2026', desc: 'NETFLIX.COM', category: 'Assinaturas', account: 'Cartão •••• 0597', amount: -55.9, bill: 'nov/2026', pluggyCategory: 'Video streaming', status: 'POSTED' },
  { id: 't7', date: '15 out 2026', desc: 'MAGAZINE EXEMPLO', category: 'Compras', account: 'Cartão •••• 0597', installment: '1/6', amount: -133.3, purchaseDate: '15/10/2026', total: 799.8, bill: 'nov/2026', pluggyCategory: 'Shopping', status: 'POSTED' },
  { id: 't8', date: '12 out 2026', desc: 'FARMÁCIA EXEMPLO', category: 'Sem categoria', account: 'Cartão •••• 0597', amount: -47.8, bill: 'nov/2026', pluggyCategory: 'Pharmacy', status: 'PENDING' },
];

export const INSTALLMENTS = [
  { name: 'LOJA ELETRO EXEMPLO', n: 3, of: 10, value: 249.9, total: 2499, ends: 'jun/27' },
  { name: 'CELULAR EXEMPLO', n: 8, of: 12, value: 301.6, total: 3619.2, ends: 'fev/27' },
  { name: 'PASSAGEM AÉREA EXEMPLO', n: 4, of: 6, value: 250, total: 1500, ends: 'dez/26' },
  { name: 'ACADEMIA ANUAL EXEMPLO', n: 5, of: 12, value: 99.9, total: 1198.8, ends: 'mai/27' },
  { name: 'MAGAZINE EXEMPLO', n: 1, of: 6, value: 133.3, total: 799.8, ends: 'mar/27' },
];
export const COMMITTED_BY_MONTH: [string, number][] = [
  ['nov', 1034.7], ['dez', 1034.7], ['jan', 784.7], ['fev', 784.7], ['mar', 483.1], ['abr', 349.8],
  ['mai', 349.8], ['jun', 249.9], ['jul', 0], ['ago', 0], ['set', 0], ['out', 0],
];

export const BILLS = [
  { status: 'open', month: 'Novembro 2026', total: 3487.12, note: 'Fecha 28/10 · vence 05/11' },
  { status: 'forecast', month: 'Dezembro 2026', total: 1034.7, note: 'Só parcelas já lançadas' },
  { status: 'paid', month: 'Outubro 2026', total: 3120.77, note: 'Paga em 05/10' },
] as const;

/** Passos para conectar o Inter PF via Meu Pluggy. */
export const CONNECT_STEPS = [
  { title: 'Crie a conexão no Meu Pluggy', description: 'Acesse meu.pluggy.ai, escolha Inter PF e autorize no app do Inter.' },
  { title: 'Copie o ID do item', description: 'Ele aparece nos detalhes da conexão no Meu Pluggy.' },
  { title: 'Cole aqui e sincronize', description: 'Buscamos contas, cartão, faturas e até 12 meses de lançamentos.' },
];
export const PLUGGY_ITEM_ID = '8f3c2d10-0000-4abc-9e00-exemplo0a91e';

export const RULES = [
  { type: 'Descrição contém', pattern: 'IFOOD', category: 'Restaurantes', count: 12 },
  { type: 'CNPJ', pattern: '00.000.000/0001-00', category: 'Eletrônicos', count: 7 },
  { type: 'MCC', pattern: '5411', category: 'Mercado', count: 58 },
  { type: 'Categoria Pluggy', pattern: 'Video streaming', category: 'Assinaturas', count: 24 },
  { type: 'Descrição contém', pattern: 'PAGAMENTO FATURA', category: 'Ignorar', count: 11 },
];

export const SYNC_RUNS = [
  { at: '23/10 07:02', src: 'Cron', st: 'ok', label: 'Sucesso', created: 14, updated: 3, removed: 1, info: '4,1 s' },
  { at: '22/10 19:40', src: 'Webhook', st: 'ok', label: 'Sucesso', created: 2, updated: 0, removed: 0, info: '0,9 s' },
  { at: '22/10 07:01', src: 'Cron', st: 'ok', label: 'Sucesso', created: 9, updated: 5, removed: 0, info: '3,8 s' },
  { at: '21/10 07:00', src: 'Cron', st: 'err', label: 'Erro', created: 0, updated: 0, removed: 0, info: 'LOGIN_ERROR · reconectar' },
  { at: '01/10 10:12', src: 'Manual', st: 'warn', label: 'Backfill 12 meses', created: 1201, updated: 0, removed: 0, info: '38 s' },
] as const;
